module.exports = __webpack_public_path__ + "static/media/user-slash.85d82564.svg";